export enum SoftwareProduct {
  PMS = "PMS",
  ROCKET = "Rocket",
  SNOOTS = "Snoots",
  ADMIN = "Admin",
  PLATFORM = "Platform",
  DROP_PAGE = "drop-page",
  BOTMASTER = "Botmaster"
}

export const SoftwareProductHost: Record<SoftwareProduct, string> = {
  [SoftwareProduct.PMS]: "pms",
  [SoftwareProduct.ROCKET]: "rocket",
  [SoftwareProduct.SNOOTS]: "snoots",
  [SoftwareProduct.ADMIN]: "admin",
  [SoftwareProduct.PLATFORM]: "platform",
  [SoftwareProduct.DROP_PAGE]: "drop-page",
  [SoftwareProduct.BOTMASTER]: "botmaster"
};

const packageJson = require("../../../package.json");

export function getCurrentSoftwareProduct(): SoftwareProduct {
  const url = location.hostname.toLowerCase();

  switch (true) {
    case url.indexOf(SoftwareProductHost[SoftwareProduct.PMS]) >= 0: {
      return SoftwareProduct.PMS;
    }
    case url.indexOf(SoftwareProductHost[SoftwareProduct.ROCKET]) >= 0: {
      return SoftwareProduct.ROCKET;
    }
    case url.indexOf(SoftwareProductHost[SoftwareProduct.ADMIN]) >= 0: {
      return SoftwareProduct.ADMIN;
    }
    case url.indexOf(SoftwareProductHost[SoftwareProduct.PLATFORM]) >= 0: {
      return SoftwareProduct.PLATFORM;
    }
    case url.indexOf(SoftwareProductHost[SoftwareProduct.DROP_PAGE]) >= 0: {
      return SoftwareProduct.DROP_PAGE;
    }
    case url.indexOf(SoftwareProductHost[SoftwareProduct.BOTMASTER]) >= 0: {
      return SoftwareProduct.BOTMASTER;
    }
    default: {
      return SoftwareProduct.SNOOTS;
    }
  }
}

export function getCurrentBuild(): string | undefined {
  return packageJson.build;
}

export function getCurrentBranch(): string | undefined {
  return packageJson.branch;
}

export function getCurrentSoftwareProductVersion(): string {
  const tokens = packageJson.version.split("-");

  let pms = "";
  let rocket = "";

  if (tokens.length === 2) {
    pms = tokens[0];
    rocket = tokens[1];
  } else {
    if (tokens.length === 3) {
      if (tokens[1].indexOf("RC") >= 0) {
        pms = `${tokens[0]}-${tokens[1]}`;
        rocket = tokens[2];
      } else {
        pms = tokens[0];
        rocket = `${tokens[1]}-${tokens[2]}`;
      }
    } else if (tokens.length === 4) {
      pms = `${tokens[0]}-${tokens[1]}`;
      rocket = `${tokens[2]}-${tokens[3]}`;
    }
  }

  switch (getCurrentSoftwareProduct()) {
    case "PMS": {
      return pms;
    }
    case "Rocket": {
      return rocket;
    }
    case "Platform": {
      return "Platform";
    }
    case "Admin": {
      return "Admin";
    }
    case "Botmaster": {
      return "botmaster";
    }
    case "Snoots":
    default: {
      return "Snoots";
    }
  }
}

export function getCurrentSoftwareProductName(): string {
  switch (getCurrentSoftwareProduct()) {
    case "PMS": {
      return packageJson.products.pms.displayName;
    }
    case "Rocket": {
      return packageJson.products.rocket.displayName;
    }
    case "Platform": {
      return packageJson.products.platform.displayName;
    }
    case "Snoots": {
      return "Snoots";
    }
    case "Botmaster": {
      return "Botmaster";
    }
    case "Admin":
    default: {
      return "Admin";
    }
  }
}

export function getCurrentSoftwareDestinationProducts():
  | "Snoots PMS"
  | "Rocket"
  | "Platform"
  | "Snoots"
  | "Admin"
  | "Botmaster" {
  switch (getCurrentSoftwareProduct()) {
    case "PMS": {
      return "Snoots PMS";
    }
    case "Rocket": {
      return "Rocket";
    }
    case "Platform": {
      return "Platform";
    }
    case "Snoots": {
      return "Snoots";
    }
    case "Botmaster": {
      return "Botmaster";
    }
    case "Admin":
    default: {
      return "Admin";
    }
  }
}
